import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { IApplication } from 'src/app/models/interfaces/application.interface';
import { ApplicationDetailContext } from '../application-detail-context';
import { ApplicationsFormComponent } from '../applications-form/applications-form.component';

@Component({
    selector: 'app-applications-detail',
    templateUrl: './applications-detail.component.html',
    styleUrls: ['./applications-detail.component.scss'],
    imports: [MatTabsModule, ApplicationsFormComponent]
})
export class ApplicationsDetailComponent implements OnInit {
    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Reference au composant groupe d'onglets.
     */
    @ViewChild(MatTabGroup)
    tabGroup: MatTabGroup;

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    @Output()
    public applicationUpdated: EventEmitter<IApplication> = new EventEmitter();

    /**
     * Indique si le composant est en mode debug (affiche des informations pour le developpeur)
     */
    public debugMode = false;

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    /**
     * Contexte du formulaire.
     */
    public _context: ApplicationDetailContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<ApplicationDetailContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: ApplicationDetailContext) {
        // set the latest value for _data BehaviorSubject
        this._context$.next(value);
    }

    constructor() {}

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        /**
         * S'abonne aux changements de contexte
         */
        this._context$.subscribe((x) => {
            this._context = x;
        });
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont sauvegardés.
     * @param application: Infos de l'application modifié.
     */
    public onApplicationUpdated(application: IApplication) {
        this.applicationUpdated.emit(application);
    }

    /**
     * Appellé lorsque des changements sur le formulaire "infos" sont annulés.
     * @param application: Infos de l'application modifié.
     */
    public onCanceled(value: boolean) {
        this.canceled.emit(value);
    }
}
